import { bynderImageUrl, computedInternalUrl, directInternalReferenceUrl, LOGO_PROJECTTION } from './projection';

export const FOOTER_QUERY = `
  *[_type == "footer"][0]{
    "footerLogo": ${LOGO_PROJECTTION},
    "footerColums": navigationColumns[]{
      "title": columnTitle,
      "isVisible": isVisible,
      "links": textLinks[]{
        ...,
        "type": link.type,
        "label": text,
        "url": ${directInternalReferenceUrl},
        "external": link.isOpenInNewTab,
        "isBold": isBold,
      }
    },
    "footerContact": {
      "contactItems": contactInfo[]{
        ...,
        "text": textLink.text,
        "url": select(
          textLink.link.type == "internal" =>
            textLink.link.internalReference->{
              "computedUrl": ${computedInternalUrl}
            }.computedUrl,
          textLink.link.url
        ),
        "type": textLink.link.type,
        "icon": icon.icon,
        "bynderIconImage": icon.bynderIconImage,
        "iconImageUrl": ${bynderImageUrl('icon.bynderIconImage')},
        "isBold": textLink.isBold,
        "isOpenInNewTab": textLink.link.isOpenInNewTab
      }
    },
    "socialLinks": socialIcons[]{
      ...,
      "linkOptional": link,
      platform,
      "url": ${directInternalReferenceUrl},
      "anchor": link.anchor,
      "linkType": link.type,
      "isOpenInNewTab": select(
        link.type == "external" => true,
        link.isOpenInNewTab
      ),
    },
    "legalInfo": legalInfo{
      "companyName": companyName,
      "abn": abn,
      "legalLinks": legalLinks[]{
        ...,
        "label": text,
        "url": ${directInternalReferenceUrl},
        "external": link.isOpenInNewTab
      },
      "additionalText": {
        "text": additionalText.text,
        "isBold": additionalText.isBold,
        "link": {
          "type": additionalText.link.type,
          "url": additionalText.link.url,
          "anchor": additionalText.link.anchor,
          "isOpenInNewTab": additionalText.link.isOpenInNewTab
        }
      }
    }
  }
`;
